function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#eca657}.cls-2{fill:#656161}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_26_Copy_7",
  "data-name": "Group 26 Copy 7"
}, /*#__PURE__*/React.createElement("g", {
  id: "floppy-disk"
}, /*#__PURE__*/React.createElement("g", {
  id: "pencil",
  transform: "rotate(180 5.979 5.969)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M.532.51A1.877 1.877 0 0 1 3.1.51l.9.866-2.564 2.457-.9-.866A1.693 1.693 0 0 1 .532.5z",
  className: "cls-1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_Copy_2",
  d: "M8.308 5.863l.928 2.188a1 1 0 0 1-1.372 1.283L5.833 8.308 0 2.474 2.457 0z",
  className: "cls-2",
  "data-name": "Shape Copy 2",
  transform: "rotate(180 4.659 4.723)"
}))));

function SvgEditMeal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4256",
    width: 11.958,
    height: 11.938,
    "data-name": "Group 4256",
    viewBox: "0 0 11.958 11.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMeal);
export default __webpack_public_path__ + "static/media/edit-meal.ec183d4f.svg";
export { ForwardRef as ReactComponent };